import { Box, Button, Modal, SpaceBetween } from '@amzn/awsui-components-core';
import React, { useContext, useEffect, useState } from 'react';
import constants from '../../../../common/constants';
import { CodeRepoFormCtx } from './form/CodeRepoFormContext';
import CodeRepoForm from './form/CodeRepoForm';

interface Props {
  visible: boolean;
  onDismiss: () => void;
}

const CodeRepoModal = (props: Props) => {
  const [isVisible, setIsVisible] = useState(props.visible);

  useEffect(() => {
    setIsVisible(props.visible);
  }, [props.visible]);

  // @ts-expect-error TS2339 - strict migration
  const { repoData, addRepoToContent, invalidFormFields, setShowValidationErrors } =
    useContext(CodeRepoFormCtx);

  const handleAddRepoClick = () => {
    if (invalidFormFields.size === 0) {
      addRepoToContent({
        url: repoData.url,
        label: repoData.title,
        branch: repoData.branch,
        repoType: repoData.repoType,
        appsecTicket: repoData.securityReviewUrl,
        appsecStatus: repoData.securityReviewStatus,
        appsecGuardian: repoData.securityGuardian,
        openSourceTicket: repoData.openSourceReviewUrl,
        openSourceStatus: repoData.openSourceReviewStatus,
      });
      setShowValidationErrors(false);
      props.onDismiss();
    } else {
      setShowValidationErrors(true);
    }
  };

  const handleCancelClick = () => {
    props.onDismiss();
  };

  const footer = (
    <Box float="right">
      <SpaceBetween direction="horizontal" size="xs">
        <Button variant="link" onClick={handleCancelClick}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleAddRepoClick}>
          {constants.CODE_REPO_ADD_BUTTON_TEXT}
        </Button>
      </SpaceBetween>
    </Box>
  );

  return (
    <Modal
      header={constants.CODE_REPO_ADD_BUTTON_TEXT}
      footer={footer}
      size="large"
      visible={isVisible}
      onDismiss={props.onDismiss}
      closeAriaLabel="Close modal"
    >
      <CodeRepoForm />
    </Modal>
  );
};

export default CodeRepoModal;
